import React from 'react';

export const HoverContext = React.createContext();
